/**
 * Created by Ning Jiang on 2024-04-15.
 */
import {DeadwoodRipSymbol} from "./DeadwoodRipSymbol";
import {DeadwoodRipSymbolState} from "./DeadwoodRipSymbolConfig";
import {gsap, TimelineLite} from "gsap";
import {DeadwoodRip} from "../DeadwoodRip";
import {MultiSprites} from "@nolimitcity/slot-game/bin/animation/MultiSprites";

export class DeadwoodRipLSymbol extends DeadwoodRipSymbol {

    private _isWildAttentionPlaying:boolean;
    private _wildPatches:PIXI.Sprite[] = [];
    private _isWild:boolean;

    constructor(symbolName:string, reelId:number, initState:DeadwoodRipSymbolState) {
        super(symbolName, reelId, initState);
    }

    // protected createState(state:DeadwoodRipSymbolState):void {
    //     super.createState(state);
    //     if(this._isWild && state != DeadwoodRipSymbolState.SPIN) {
    //         this.showWild();
    //     }
    // }

    protected playKill():TimelineLite {
        const tl = super.playKill();
        tl.add(() => {
            this._parts.forEach(p => {
                gsap.to(p, {alpha : 1, duration : 0.3});
            });
        }, `-=0.3`);
        return tl;
    }

    public playIndividualKill():TimelineLite {
        const tl = super.playIndividualKill();
        tl.add(() => {
            if(!this.removed) {
                this._parts.forEach(p => {
                    gsap.to(p, {alpha : 1, duration : 0.3});
                });
            }
        }, `-=0.3`);

        return tl;
    }

    public playWildAttention():TimelineLite {
        this._isWildAttentionPlaying = true;
        if(!this._partPatchContainer) {
            this._partPatchContainer = new PIXI.Container();
            this.updateLayers();
        }
        const tl = new TimelineLite();
        const wild = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`WILD/WILD`)[0]);
        wild.anchor.set(0.5);
        wild.alpha = 0;
        this._partPatchContainer.addChild(wild);
        tl.add(gsap.to(wild, 0.1, {alpha : 0.5}));
        tl.add(gsap.to(wild, 0.2, {alpha : 0}), `+=0.15`);
        tl.add(() => {
            this._partPatchContainer.removeChild(wild);
            wild.destroy();
        });
        return tl;
        // TODO: loop attention with wild patch.
    }

    public stopWildAttention():TimelineLite {
        this._isWildAttentionPlaying = false;
        const tl = new TimelineLite();
        tl.add(() => {}, 0.1);
        return tl;
    }

    public showWild():TimelineLite {
        this._isWild = true;
        if(!this._partPatchContainer) {
            this._partPatchContainer = new PIXI.Container();
            this.updateLayers();
        }
        const w = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`WILD/WILD`)[0]);
        w.anchor.set(0.5);
        w.alpha = 0;
        this._partPatchContainer.addChild(w);
        this._partPatches.push(w);

        const tl = new TimelineLite();
        tl.add([
            gsap.to(w, {duration : 0.18, alpha : 1}),
            gsap.fromTo(w.scale, {x : 1.2, y : 1.2}, {duration : 0.18, x : 1, y : 1})
        ]);
        return tl;
    }

    protected addSplitPartOverlay(part:MultiSprites):void {
        if(!this._isWild) {
            return;
        }
        if(!this._partPatchContainer) {
            this._partPatchContainer = new PIXI.Container();
            this.updateLayers();
        }
        const w = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures(`WILD/WILD`)[0]);
        w.anchor.set(0.5);
        w.position.set(part.x, part.y);
        const scale = this.symbolSize == 4 ? 0.6 : (this.symbolSize == 2 ? 0.9 : 1);
        w.scale.set(scale);
        this._partPatchContainer.addChild(w);
        this._partPatches.push(w);
    }
}